import type { LegacyRole } from "./types";

/** Roles that may manage users within an org (dual-mode fallback). */
export const USER_MANAGEMENT_ROLES: readonly LegacyRole[] = [
  "admin",
  "waste_outlet_admin",
  "waste_outlet_ops_manager",
  "recycler_admin",
  "recycler_ops_manager",
  "truck_co_admin",
  "truck_co_ops_manager",
];

/** Roles with pickup order write access (waste outlet). */
export const PICKUP_ORDER_WRITE_ROLES: readonly LegacyRole[] = [
  "waste_outlet_admin",
  "waste_outlet_ops_manager",
  "waste_outlet_staff",
];

/** Roles with pickup order list/read access. */
export const PICKUP_ORDER_LIST_ROLES: readonly LegacyRole[] = [
  ...PICKUP_ORDER_WRITE_ROLES,
  "admin",
];

export const ORG_ADMIN_ROLES: readonly LegacyRole[] = [
  "admin",
  "waste_outlet_admin",
  "recycler_admin",
  "truck_co_admin",
];

export const ADMIN_READ_ONLY_ROLE = "admin_read_only" as const;

export function hasLegacyRole(roles: readonly string[], allowed: readonly string[]): boolean {
  if (!roles.length) {
    return false;
  }
  const set = new Set(allowed);
  return roles.some((r) => set.has(r));
}
